import React, { PureComponent } from 'react';
import * as styles from './style';
import ActionBtn from '../ActionBtn';
import { VARIATIONS_ACTIONS_TYPE } from '../../helpers/constants';
import withVariations from '../../containers/GlobalVariations';
import { getVariationsPriceTypeLabel, getVariationOptionLabel } from '../../helpers/variations';
import { formatPrice } from '../../helpers/price';
import { BLUE_LIGHTER } from '../../styles/variables';

class VariationItem extends PureComponent {
  state = {
    isOpen: false,
  };

  componentDidMount() {
    const { toggleItems } = this.props;

    if (toggleItems) {
      toggleItems();
    }
  }

  getOptionsCollapsed = options => {
    return options
      .filter((_, idx) => idx < 3)
      .map(opt => opt.name)
      .join(' - ');
  };

  toggleVariationItems = () => {
    const { isOpen } = this.state;
    const { toggleItems } = this.props;
    this.setState(
      {
        isOpen: !isOpen,
      },
      () => {
        if (toggleItems) {
          toggleItems();
        }
      }
    );
  };

  render() {
    const {
      variation,
      className,
      provided,
      isDragging,
      noMargin,
      showActions,
      deleteOnly,
      isDraggingOver,
      style,
      onClickVariationActions,
    } = this.props;
    const { isOpen } = this.state;
    return (
      <styles.VariationItem
        ref={provided && provided.innerRef}
        id={`variation-list-${variation.id}`}
        className={className}
        noMargin={noMargin}
        open={isOpen}
        {...provided && provided.dragHandleProps}
        {...provided && provided.draggableProps}
        isDragging={isDragging}
        isDraggingOver={isDraggingOver}
        style={style}
      >
        <styles.Header>
          <styles.FirstBar>
            <span>{variation.name}</span>
            {showActions && (
              <ActionBtn
                className="variation-item-action-btn"
                id={`variation-item-action-btn-${variation.id}`}
                items={deleteOnly ? [VARIATIONS_ACTIONS_TYPE[1]] : VARIATIONS_ACTIONS_TYPE}
                onClick={onClickVariationActions}
                buttonStyle={{
                  marginTop: '-3px',
                  marginRight: '-10px',
                }}
                dotStyle={{
                  backgroundColor: BLUE_LIGHTER,
                  marginRight: '3px',
                }}
                hoverStyle={{
                  backgroundColor: BLUE_LIGHTER,
                }}
              />
            )}
          </styles.FirstBar>
          <styles.SecondBar>
            <span>{getVariationOptionLabel(variation.min, variation.max)}</span>
            <span>{getVariationsPriceTypeLabel(variation.priceType)}</span>
          </styles.SecondBar>
        </styles.Header>
        <styles.Body open={isOpen}>
          <styles.Container>
            {isOpen ? (
              variation.options.map(item => (
                <styles.ListItem
                  id={`variation-item-${variation.id}-option-${item.id}`}
                  key={item.id}
                >
                  <styles.Name className="variation-option-name">{item.name}</styles.Name>
                  <styles.Price className="variation-option-name">
                    {formatPrice(item.originalPrice / 100)}
                  </styles.Price>
                </styles.ListItem>
              ))
            ) : (
              <styles.CollapsedItem>
                <styles.InlineItems>
                  {this.getOptionsCollapsed(variation.options)}
                </styles.InlineItems>
              </styles.CollapsedItem>
            )}
          </styles.Container>

          <styles.ToggleButton
            floatingRight={!isOpen}
            onClick={this.toggleVariationItems}
            className="variation-item-toggle-btn"
            id={`variation-item-toggle-btn-${variation.id}`}
          >
            {isOpen ? 'Esconder' : 'Mostrar'}
          </styles.ToggleButton>
        </styles.Body>
      </styles.VariationItem>
    );
  }
}

VariationItem.defaultProps = {
  showActions: true,
  deleteOnly: false,
  noMargin: false,
};

export default withVariations(VariationItem);



// WEBPACK FOOTER //
// ./src/components/VariationItem/index.js